import formatISODate from "@mapmycustomers/shared/util/formatters/formatISODate";

import { parseApiDateWithTz } from "@app/util/parsers";

// Org-tz calendar-day key ("yyyy-MM-dd") for a BE timestamp — same convention as
// UserLocation.createdAtIsoDate, so timeline day-grouping matches the rest of Field View.
const getEventDayKey = (isoDateTime: string, orgTimeZone: string | undefined): string =>
  formatISODate(parseApiDateWithTz(isoDateTime, orgTimeZone));

export default getEventDayKey;
